import { setAlert } from '../../alert';
import api from '../../../util/api';
import {
    START_LOADING,
    START_POSTING,
    GET_EMISSION_FACTORS_FAIL,
    GET_EMISSION_FACTORS_SUCCESS,
    POST_EMISSION_FACTORS_FAIL,
    POST_EMISSION_FACTORS_SUCCESS,
    // EMISSIONS
    START_COMPANY_SUMMARY_LOADING,
    START_GROUP_SUMMARY_LOADING,
    START_COMPANY_SCOPE_ONE_LOADING,
    START_GROUP_SCOPE_ONE_LOADING,
    START_COMPANY_SCOPE_TWO_LOADING,
    START_GROUP_SCOPE_TWO_LOADING,
    START_COMPANY_SCOPE_THREE_LOADING,
    START_GROUP_SCOPE_THREE_LOADING,
    // COMPANY
    GET_COMPANY_EMISSIONS_SUMMARY_SUCCESS,
    GET_COMPANY_EMISSIONS_SUMMARY_FAIL,
    GET_COMPANY_EMISSIONS_SCOPE_ONE_SUCCESS,
    GET_COMPANY_EMISSIONS_SCOPE_ONE_FAIL,
    GET_COMPANY_EMISSIONS_SCOPE_TWO_SUCCESS,
    GET_COMPANY_EMISSIONS_SCOPE_TWO_FAIL,
    GET_COMPANY_EMISSIONS_SCOPE_THREE_SUCCESS,
    GET_COMPANY_EMISSIONS_SCOPE_THREE_FAIL,
    // GROUP
    GET_GROUP_EMISSIONS_SUMMARY_SUCCESS,
    GET_GROUP_EMISSIONS_SUMMARY_FAIL,
    GET_GROUP_EMISSIONS_SCOPE_ONE_SUCCESS,
    GET_GROUP_EMISSIONS_SCOPE_ONE_FAIL,
    GET_GROUP_EMISSIONS_SCOPE_TWO_SUCCESS,
    GET_GROUP_EMISSIONS_SCOPE_TWO_FAIL,
    GET_GROUP_EMISSIONS_SCOPE_THREE_SUCCESS,
    GET_GROUP_EMISSIONS_SCOPE_THREE_FAIL,
    EXPORT_COMPANY_EMISSIONS_SUMMARY_SUCCESS,
    EXPORT_COMPANY_EMISSION_SUMMARY_FAIL,
    EXPORT_GROUP_EMISSIONS_SUMMARY_FAIL,
    EXPORT_GROUP_EMISSIONS_SUMMARY_SUCCESS
} from '../types/07-emission-factors';
import {
    API_EMISSION_FACTORS,
    API_GET_COMPANY_EMISSIONS_SUMMARY,
    API_GET_GROUP_EMISSIONS_SUMMARY,
    API_GET_COMPANY_EMISSIONS_SCOPE_ONE,
    API_GET_COMPANY_EMISSIONS_SCOPE_TWO,
    API_GET_COMPANY_EMISSIONS_SCOPE_THREE,
    API_GET_GROUP_EMISSIONS_SCOPE_ONE,
    API_GET_GROUP_EMISSIONS_SCOPE_TWO,
    API_GET_GROUP_EMISSIONS_SCOPE_THREE,
    API_EXPORT_COMPANY_EMISSIONS_SUMMARY,
    API_EXPORT_GROUP_EMISSIONS_SUMMARY
} from '../constants/07-emission-factors';

const config = {
    headers: {
        'Content-Type': 'application/json'
    },
};

export const getEmissionFactors = (company, year, category) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_EMISSION_FACTORS + `/${company}/${year}/${category}`,
            config
        );
        dispatch({
            type: GET_EMISSION_FACTORS_SUCCESS,
            payload: data
        });
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_EMISSION_FACTORS_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postEmissionFactors = (formData, company, year, category) => async dispatch => {
    try {
        dispatch({ type: START_POSTING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_EMISSION_FACTORS + `/${company}/${year}/${category}`,
            formData,
            config
        );
        dispatch({
            type: POST_EMISSION_FACTORS_SUCCESS,
            payload: data
        });
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: POST_EMISSION_FACTORS_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getCompanyEmissionsSummary = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_COMPANY_SUMMARY_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_COMPANY_EMISSIONS_SUMMARY + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_COMPANY_EMISSIONS_SUMMARY_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_COMPANY_EMISSIONS_SUMMARY_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getCompanyEmissionsScopeOne = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_COMPANY_SCOPE_ONE_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_COMPANY_EMISSIONS_SCOPE_ONE + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_COMPANY_EMISSIONS_SCOPE_ONE_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_COMPANY_EMISSIONS_SCOPE_ONE_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getCompanyEmissionsScopeTwo = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_COMPANY_SCOPE_TWO_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_COMPANY_EMISSIONS_SCOPE_TWO + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_COMPANY_EMISSIONS_SCOPE_TWO_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_COMPANY_EMISSIONS_SCOPE_TWO_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getCompanyEmissionsScopeThree = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_COMPANY_SCOPE_THREE_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_COMPANY_EMISSIONS_SCOPE_THREE + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_COMPANY_EMISSIONS_SCOPE_THREE_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_COMPANY_EMISSIONS_SCOPE_THREE_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getGroupEmissionsSummary = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_GROUP_SUMMARY_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_GROUP_EMISSIONS_SUMMARY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_GROUP_EMISSIONS_SUMMARY_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_GROUP_EMISSIONS_SUMMARY_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getGroupEmissionsScopeOne = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_GROUP_SCOPE_ONE_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_GROUP_EMISSIONS_SCOPE_ONE + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_GROUP_EMISSIONS_SCOPE_ONE_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_GROUP_EMISSIONS_SCOPE_ONE_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getGroupEmissionsScopeTwo = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_GROUP_SCOPE_TWO_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_GROUP_EMISSIONS_SCOPE_TWO + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_GROUP_EMISSIONS_SCOPE_TWO_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_GROUP_EMISSIONS_SCOPE_TWO_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getGroupEmissionsScopeThree = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_GROUP_SCOPE_THREE_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_GROUP_EMISSIONS_SCOPE_THREE + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_GROUP_EMISSIONS_SCOPE_THREE_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_GROUP_EMISSIONS_SCOPE_THREE_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const exportCompanyEmissionsSummary = (company, year) => async dispatch => {
    try {
        const response = await api().get(process.env.REACT_APP_API_URL + API_EXPORT_COMPANY_EMISSIONS_SUMMARY + `/${company}/${year}`,
            {
                ...config,
                responseType: 'blob',
            }
        );
        dispatch({
            type: EXPORT_COMPANY_EMISSIONS_SUMMARY_SUCCESS,
            payload: response.data
        })
        dispatch(setAlert('Document Downloaded Successfully.', 'success'))
        return response
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: EXPORT_COMPANY_EMISSION_SUMMARY_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const exportGroupEmissionsSummary = (company, group, year) => async dispatch => {
    try {
        const response = await api().get(process.env.REACT_APP_API_URL + API_EXPORT_GROUP_EMISSIONS_SUMMARY + `/${company}/${group}/${year}`,
            {
                ...config,
                responseType: 'blob',
            }
        );
        dispatch({
            type: EXPORT_GROUP_EMISSIONS_SUMMARY_SUCCESS,
            payload: response.data
        })
        dispatch(setAlert('Document Downloaded Successfully.', 'success'))
        return response
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: EXPORT_GROUP_EMISSIONS_SUMMARY_FAIL,
            payload: error.response.data.detail
        })
    }
}
